"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _reactRedux = require("react-redux");

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _userHelpers = require("composer-lib/lib/helpers/userHelpers");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _SaveStatus = _interopRequireDefault(require("composer-lib/components/composer/SaveStatus"));

var _Users = _interopRequireDefault(require("composer-lib/data/model/Users"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    lock: state.lock,
    saveState: state.save,
    users: state.users
  };
};

var mapDispatchToProps = {};
var SaveStatusContainer = (0, _createReactClass.default)({
  displayName: "SaveStatusContainer",
  propTypes: {
    auth: _propTypes.default.object,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    onClick: _propTypes.default.func,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    users: _propTypes.default.instanceOf(_Users.default).isRequired
  },
  getAuthor: function getAuthor() {
    var _this$props = this.props,
        composition = _this$props.composition,
        users = _this$props.users;
    var authorId = composition.getIn(['data', 'authorId']);
    return (0, _userHelpers.parseUser)(authorId, users);
  },
  render: function render() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        composition = _this$props2.composition,
        lock = _this$props2.lock,
        onClick = _this$props2.onClick,
        saveState = _this$props2.saveState;
    var locked = (0, _lockHelpers.compositionLocked)(lock, auth, saveState);
    var updated = composition.updated;
    return _react.default.createElement(_SaveStatus.default, {
      compositionLastUpdated: updated,
      getAuthor: this.getAuthor,
      locked: locked,
      onClick: onClick,
      status: saveState.status
    });
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(SaveStatusContainer);

exports.default = _default;
module.exports = exports.default;